/**
 * BrandLogo.ts
 * Official ApnaGuru Brand Logo component.
 * Uses exact PNG brand logo images uploaded in public/ directory:
 * - Apnaguru-Logo-Light.png
 * - Apnaguru-Logo.png
 * - Apnaguru-Logo-Vertical-Light.png
 * - Apnaguru-Logo-Vertical.png
 */

import logoLight from '../assets/logo/Apnaguru-Logo-Light.png';
import logoDark from '../assets/logo/Apnaguru-Logo.png';
import logoVertLight from '../assets/logo/Apnaguru-Logo-Vertical-Light.png';
import logoVertDark from '../assets/logo/Apnaguru-Logo-Vertical.png';

export class BrandLogo {
  /**
   * Renders horizontal brand logo
   */
  public static renderHTML(size: 'sm' | 'md' | 'lg' = 'md'): string {
    const height = size === 'sm' ? 32 : size === 'lg' ? 48 : 38;

    return `
      <div class="brand-logo-wrapper" style="display: inline-flex; align-items: center; cursor: pointer; user-select: none;">
        <!-- Theme-aware Logo Images -->
        <img src="${logoLight}" alt="ApnaGuru Logo" class="brand-logo-img logo-for-dark" style="height: ${height}px; width: auto; object-fit: contain;" />
        <img src="${logoDark}" alt="ApnaGuru Logo" class="brand-logo-img logo-for-light" style="height: ${height}px; width: auto; object-fit: contain;" />
      </div>
    `;
  }

  /**
   * Renders vertical brand logo variation (for footers or hero cards)
   */
  public static renderVerticalHTML(size: 'sm' | 'md' | 'lg' = 'md'): string {
    const height = size === 'sm' ? 60 : size === 'lg' ? 100 : 80;

    return `
      <div class="brand-logo-vertical-wrapper" style="display: inline-flex; flex-direction: column; align-items: center; cursor: pointer; user-select: none;">
        <img src="${logoVertLight}" alt="ApnaGuru Logo" class="brand-logo-img logo-vertical-dark" style="height: ${height}px; width: auto; object-fit: contain;" />
        <img src="${logoVertDark}" alt="ApnaGuru Logo" class="brand-logo-img logo-vertical-light" style="height: ${height}px; width: auto; object-fit: contain;" />
      </div>
    `;
  }
}

